import React from 'react';
import MUIAppBar from '@mui/material/AppBar';
export const AppBar = props => /*#__PURE__*/React.createElement(MUIAppBar, props);
export default AppBar;